<template>
  <div class="row">
    <label class="ls-label">
      <span class="ls-label-text col-xs-12">{{ $t('settings.label.billing_setting') }}</span>
      <div class="col-xs-12 col-md-7 col-sm-7 col-lg-7">
        <div class="ls-custom-select">
          <select v-model="$parent.$parent.$data.selectedBillingSetting" class="ls-select" @change.prevent="changeBillingSetting()">
            <option value="1">{{ $t('settings.billing_attributes.contract_overdue') }}</option>
            <option value="2">{{ $t('settings.billing_attributes.contract_cancel_overdue') }}</option>
            <option value="3">{{ $t('settings.billing_attributes.contract_cancel_pending') }}</option>
            <option value="4">{{ $t('settings.billing_attributes.invoice_interval') }}</option>
            <option value="5">{{ $t('settings.billing_attributes.payment_max_split')}}</option>
            <option value="6">{{ $t('settings.billing_attributes.payment_days_to_generate')}}</option>
            <option value="23">{{ $t('settings.billing_attributes.invoices_generation_on_overdue')}}</option>
          </select>
        </div>
      </div>
    </label>
  </div>
</template>
<script>
  import { mapMutations } from 'vuex'

  export default {
    methods: {
      ...mapMutations(['clearFlash']),
      changeBillingSetting () {
        this.clearFlash()
        this.$parent.$parent.getBillingSetting(this.$parent.$parent.$data.selectedBillingSetting)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectBillingSetting.vue?e78bcee6